import { z } from 'zod'

import { CarouselDtoSchema } from '../components'

import { HomeDtoBaseSchema } from './HomeDtoBase'

export const HomeAuthenticatedDtoSchema = HomeDtoBaseSchema.extend({
  content: z.array(CarouselDtoSchema),
})

export type HomeAuthenticatedDto = z.infer<typeof HomeAuthenticatedDtoSchema>

export const isHomeAuthenticatedDto = (x: unknown): x is HomeAuthenticatedDto =>
  HomeAuthenticatedDtoSchema.safeParse(x).success
